import React from 'react';
import PropTypes from 'prop-types';

import DetailsCard from 'bundles/apex/card/details';
import Text from 'bundles/apex/deals/show/listing/values/value';
import { USD } from 'helpers/formatters/number_formats';

const ListingCard = ({ listing }) => {
  return (
    <DetailsCard label="Sale Listing">
      <Text
        name="salePrice"
        value={listing.salePrice && USD.format(listing.salePrice)}
      />
      <Text name="saleDescription" />
    </DetailsCard>
  );
};

ListingCard.propTypes = {
  listing: PropTypes.object.isRequired,
};

export default ListingCard;
